import React, { memo } from 'react';
import PostComment from '../network-forms/submission-comments/post-comment';
import SubmissionCommentsList
  from '../network-forms/submission-comments/submission-comments-list';
import type {
  FormSubmissionComment, FormattedFormSubmittionComment,
  FormSubmissionConfig, GetFormSubmissionsCommentsMeta
} from '@modules/forms/types';
import type { ApiResponse } from '@common/services/api/types';

type SubmissionCommentsProps = {
  organisationId: string;
  submissionId: string;
  comments: FormattedFormSubmittionComment[] | null;
  getComments: () => Promise<
    ApiResponse<FormSubmissionComment[], GetFormSubmissionsCommentsMeta>
  >;
  addComment: (comment: FormSubmissionComment) => void;
  onDelete: (commentId: string) => Promise<void>;
  submissionConfig: FormSubmissionConfig;
};

const SubmissionComments = memo(({
  organisationId,
  submissionId,
  comments,
  getComments,
  addComment,
  onDelete,
  submissionConfig
}: SubmissionCommentsProps) => {
  return (
    <div className="comments">
      <SubmissionCommentsList
        comments={comments}
        getComments={getComments}
        onDelete={onDelete}
        submissionConfig={submissionConfig}
      />
      <hr />
      <PostComment
        organisationId={organisationId}
        submissionId={submissionId}
        addComment={addComment}
      />
    </div>
  );
});

export default SubmissionComments;
